import { QuestionBase } from './question-base.model';

export class MultiDropdownQuestion extends QuestionBase<string> {
   controlType = 'multi-dropdown';
   id: string;
   getterKey = null;
   getterValue = null;
   param: boolean;
   disabled: boolean;
   options: { key: string, value: string }[] = [];
   config: any;

   visible: string;

   constructor(options: {} = {}) {
      super(options);
      this.options = options['options'] || []; this.id = options['id'];
      this.getterKey = options['getterKey'] || 'key';
      this.getterValue = options['getterValue'] || 'value';
      this.param = options['param'] || false;
      this.config = options['config'] || null;
      this.visible = options['visible'] || "true";
      this.disabled = options['disabled'] || false;
   }
}
